import React, { PureComponent } from 'react';
import { object, node, shape, arrayOf } from 'prop-types';
import { connectStateResults } from 'react-instantsearch-core';
import { scroll, getScroll } from 'utils';
import { Provider } from './AutoScrollContext';

class AutoScrollProvider extends PureComponent {
    static propTypes = {
        searchState: object, // eslint-disable-line react/no-unused-prop-types, react/forbid-prop-types
        // eslint-disable-next-line react/no-unused-prop-types
        searchResults: shape({
            hits: arrayOf(object),
        }),
        children: node.isRequired,
    };

    static defaultProps = {
        searchState: {},
        searchResults: {
            hits: [],
        },
    };

    constructor(props) {
        super(props);

        this.state = {
            needScroll: false,
            isMobileMode: false, // eslint-disable-line react/no-unused-state
        };
    }

    static getDerivedStateFromProps(props, state) {
        let updateState = {};
        if (
            !state.needScroll &&
            getScroll().scrollY > 0 &&
            props.searchState &&
            state.searchState &&
            props.searchState.configure?.page &&
            (props.searchState.configure?.page !==
                state.searchState.configure?.page ||
                props.searchState.sortBy !== state.searchState.sortBy)
        ) {
            updateState.needScroll = true;
        }

        if (props.searchState !== state.searchState) {
            updateState.searchState = {
                ...props.searchState,
                configure: {
                    ...props.searchState?.configure,
                    page: props.searchState?.configure?.page || 1,
                },
            };
        }

        if (props.searchResults !== state.searchResults) {
            updateState.searchResults = props.searchResults;
        }

        if (Object.keys(updateState).length === 0) {
            updateState = null;
        }
        return updateState;
    }

    componentDidUpdate(prevProps, prevState) {
        const { needScroll } = this.state;

        if (needScroll && !prevState.needScroll) {
            scroll(0, 500, window, () => {
                if (!this.unmounted) {
                    setTimeout(() => {
                        window.scrollTo(0, 0);
                        this.setState({ needScroll: false });
                    }, 0);
                }
            });
        }
    }

    componentWillUnmount() {
        this.unmounted = true;
        if (this.mobileMatchMedia) {
            this.mobileMatchMedia.removeListener(
                this.handleMobileMatchMediaChange,
            );
        }
    }

    handleMobileMatchMediaChange = ({ matches: isMobileMode }) => {
        this.setState({ isMobileMode }); // eslint-disable-line react/no-unused-state
    };

    render() {
        return (
            <Provider value={this.state.needScroll}>
                {this.props.children}
            </Provider>
        );
    }
}

export default connectStateResults(AutoScrollProvider);
